import { render, staticRenderFns } from "./MenuTeacher.vue?vue&type=template&id=34c766bc&scoped=true"
import script from "./MenuTeacher.vue?vue&type=script&lang=js"
export * from "./MenuTeacher.vue?vue&type=script&lang=js"
import style0 from "./MenuTeacher.vue?vue&type=style&index=0&id=34c766bc&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "34c766bc",
  null
  
)

export default component.exports